/* © 2014 - Copyright of Aetonix Systems Inc - All Rights Reserved. Patent pending.
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Aetonix, Sep 08, 2016
 * For information or permission request, email info@aetonixsystems.com
 */



var Model = require("../types/Model.js");
const AsyncStorage = require("@react-native-async-storage/async-storage").default;

// TODO: Be more smart with added and removed events

/**
 * Keeps track of which manage group is actively being viewed
 * @type {Model}
 */
module.exports = Model({
	name: "activemanagegroup",
	init,
	triggers,
	listeners
});

function listeners(){
	return {
		"managegroups:updated": handle_list_updated
	};
}

function triggers () {
	return {
		"load": set_group,
		"clear": unset_group
	};
}

function init() {

	AsyncStorage.getItem("active_managed_group").then((group) => {
		this.push(group);
		this.emit("managedusers:trigger:group:load", {
			group
		});
	})
}

function set_group({group}){

	if(group === "all") {
		AsyncStorage.setItem('active_managed_group',"all")
		return unset_group.call(this);
	} 
	this.push(group);
	AsyncStorage.setItem('active_managed_group',group)
	this.emit("managedusers:trigger:group:load", {
		group
	});
}

function unset_group(){
	this.push(null);
	this.emit("managedusers:trigger:group:clear");
}

function handle_list_updated(list){
	const viewing = this.data;
	if(!viewing) return;
	const current = list.find(e => e._id === viewing);
	if(!current) unset_group.call(this);
}
